import script from "./ModuleView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModuleView.vue?vue&type=script&setup=true&lang=ts"

import "./ModuleView.vue?vue&type=style&index=0&id=cbfae618&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbfae618"]])

export default __exports__